import { Container1, Container2, Container3, Container4, Design1, TextBox, TextBox2, Wrapper } from "./style";
const Com2 = () => {
  return (
    <Wrapper>
      <Container1>
        <img loading="lazy" src="/assets/img/AffilicateCreator_1.png" alt="phoneImg" />
      </Container1>

      <Container3>
        <TextBox>
          <div>Step. 01</div>
          <div>
            <span>{"S-Store 계정 만들기"} </span>
          </div>
          <div>
            <span>{"Connected S-Store 버튼을 눌러 S-Store 계정을 생성하세요."}</span>
            <span>{" Sketch Wallet 회원이 아니신가요? S-Store는 Sketch Wallet 회원만 이용이 가능합니다 "}</span>
          </div>
        </TextBox>
      </Container3>
      <Design1></Design1>
    </Wrapper>
  );
};

export default Com2;
